import { makeRequest } from '../../../../../api/makeRequest';

export const acceptIncomingInvite = (data) => makeRequest({
  url: '/sebTariff/acceptInvite/',
  method: 'post',
  headers: {
    'content-type': 'application/json',
  },
  data,
});
